import { createRoot } from 'react-dom/client';

import * as Sentry from '@sentry/react';
import { Provider } from 'react-redux';
import { store } from 'app/store';
import { addAxiosContext } from 'utils/sentryAxiosContext';

// scroll bar
import 'simplebar-react/dist/simplebar.min.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// google-fonts
import '@fontsource/public-sans/400.css';
import '@fontsource/public-sans/500.css';
import '@fontsource/public-sans/600.css';
import '@fontsource/public-sans/700.css';
import '@fontsource/inter-tight/400.css';

// project import
import App from './App';
import { ConfigProvider } from '@trendiolive/trendio-selfcare-ui-kit';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_ENVIRONMENT,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  tracePropagationTargets: ['localhost', import.meta.env.VITE_SELLER_API_URL],
  beforeSend: addAxiosContext
});

const container = document.getElementById('root');
const root = createRoot(container!);

// ==============================|| MAIN - REACT DOM RENDER ||============================== //

root.render(
  <Provider store={store}>
    <ConfigProvider>
      <App />
    </ConfigProvider>
  </Provider>
);
